import { render, staticRenderFns } from "./operateAddorEdit.vue?vue&type=template&id=f0babda4&scoped=true&"
import script from "./operateAddorEdit.vue?vue&type=script&lang=js&"
export * from "./operateAddorEdit.vue?vue&type=script&lang=js&"
import style0 from "./operateAddorEdit.vue?vue&type=style&index=0&id=f0babda4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0babda4",
  null
  
)

export default component.exports